var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"part-label-connector",style:(_vm.style),attrs:{"data-left-shift":_vm.isLeftShiftBorder,"data-bottom-shift":_vm.isBottomShiftBorder}})
}
var staticRenderFns = []

export { render, staticRenderFns }